import React from 'react'
import {fetchPlanIcon} from '../../../../../../utils/fetch-plan-icon'
import {
  CardPlanHeaderStyle,
  KP11LinkCatalogCardWrapperStyle,
} from '../kp-11Link-catalog-cards-style'

// import your expanded components
import {KP11LinkMCCardComponent} from './kp-11Link-mc-card'
import {KP11LinkGPCardComponent} from './kp-11Link-gp-card'
import {KP11LinkThryvLeadsCardComponent} from './kp-11Link-thryvLeads-card'
import {KP11LinkSeoCardComponent} from './kp-11Link-seo-card'
import {KP11LinkSocialAdsCardComponent} from './kp-11link-socialAds-card'
import {KP11LinkWCCardComponent} from './kp-11Link-wc-card'
import {GenericCatalogCard} from './kp-11Generic-catalog-card'
import {KP11KeapAddonsCardComponent} from './kp-11-keap-add-ons-cards/kp-11KeapAddons-catalog-card'
import {KP11ThryvAddonsCardComponent} from './kp-11-thryv-add-ons-cards/kp-11ThryvAddons-catalog-card'
import Kp11KeapCard from './kp-11Keap-card'
import {KP11LinkHomeservicesCardComponent} from './kp-11Link-homeservices-card'
import {Icon} from '@thryvlabs/maverick'
import {KP11LinkBCCardComponent} from './kp-11Link-bc-card'
import {KP11LinkThryvGrowthPlatformCardComponent} from './kp-11Link-thryvGrowthPlatform-card'

const ExpandedContentMap = {
  marketingcenter: {
    component: KP11LinkMCCardComponent,
    extraProps: {},
  },
  thryvgrowthplatform: {
    component: KP11LinkThryvGrowthPlatformCardComponent,
    extraProps: {},
  },
  businesscenter: {
    component: KP11LinkBCCardComponent,
    extraProps: {},
  },
  seo: {
    component: KP11LinkSeoCardComponent,
    extraProps: {},
  },
  thryvLeads: {
    component: KP11LinkThryvLeadsCardComponent,
    extraProps: {},
  },
  thryvGrowthPackage: {
    component: KP11LinkGPCardComponent,
    extraProps: {},
  },
  'thryvadd-ons': {
    component: KP11ThryvAddonsCardComponent,
    extraProps: {},
  },
  socialAds: {
    component: KP11LinkSocialAdsCardComponent,
    extraProps: {},
  },
  workforcecenter: {
    component: KP11LinkWCCardComponent,
    extraProps: {},
  },
  keap: {
    component: Kp11KeapCard,
    extraProps: {},
  },
  'keapadd-ons': {
    component: KP11KeapAddonsCardComponent,
    extraProps: {},
  },
  homeservices: {
    component: KP11LinkHomeservicesCardComponent,
    extraProps: {},
  },
  partnercertification: {
    component: KP11KeapAddonsCardComponent,
    extraProps: {},
  },
  adsboost: {
    component: KP11ThryvAddonsCardComponent,
    extraProps: {},
  },
  brandboost: {
    component: KP11ThryvAddonsCardComponent,
    extraProps: {},
  },
  socialboost: {
    component: KP11ThryvAddonsCardComponent,
    extraProps: {},
  },
  searchboost: {
    component: KP11ThryvAddonsCardComponent,
    extraProps: {},
  },
}

const MARKETING_BOOST_TITLES = [
  'Ads Boost',
  'Brand Boost',
  'Social Boost',
  'Search Boost',
]

// Fallback default if groupKey is not matched
// const DefaultExpandedContent = KP11LinkDefaultCardComponent
const DefaultExpandedContent = GenericCatalogCard

// Catalog card component
export const KP11LinkGCardComponent = ({
  selectedCountry,
  groupKey,
  title,
  items,
  expanded,
  // setExpanded,
  onExpand,
  onSelectItem,
  onSEOAddonChange,
  disabled,
  disabledItems = {},
  onRemove,
  hasItem,
  showAdd,
  addedToCart,
  groupCustomFields,
  onGroupCustomFieldsUpdate,
}) => {
  let iconName = ''

  if (items && items.length > 0) {
    const firstItem = items[0]
    // const name = firstItem?.name?.toLowerCase() || ''
    const code = firstItem?.code?.toLowerCase() || ''

    if (MARKETING_BOOST_TITLES.includes(title)) {
      iconName = title
    } else if (code === 'appmarket-5-thryv-m2m') {
      iconName = 'Growth Package'
    } else if (
      code.includes('bronze') ||
      code.includes('silver') ||
      code.includes('gold')
    ) {
      iconName = 'Social Ads'
    } else if (code.includes('max')) {
      iconName = 'Keap'
    } else if (
      code === 'keap_kcc-cert-5-fee' ||
      code === 'keap_kcp-cert-5-fee'
    ) {
      iconName = 'Keap'
    } else {
      // iconName = firstItem.name
      iconName = title
    }
  }

  const cardIcon = fetchPlanIcon(iconName)

  // const cardIcon = fetchPlanIcon(items && items.length > 0 ? items[0].name : '')

  const config = ExpandedContentMap[groupKey]
  const ExpandedContent = config?.component || DefaultExpandedContent
  const extraProps = config?.extraProps || {}

  const getGroupLevelStatus = () => {
    if (groupKey === 'thryvadd-ons') {
      return false
    }
    return disabled
  }

  return (
    <KP11LinkCatalogCardWrapperStyle>
      {/* card header with action buttons */}
      <div
        className={`${
          getGroupLevelStatus() ? 'disable-with-opacity' : ''
        } w-100`}
      >
        <CardPlanHeaderStyle
          onClick={() => !getGroupLevelStatus() && onExpand()}
        >
          <div className="card-heading">
            <div className="card-icon">
              <img
                src={cardIcon?.icon}
                alt="plan logo"
                className="options-logo rounded"
              />
            </div>
            <div className="card-title-text">{title}</div>
          </div>

          <div>
            <Icon
              type={'solid'}
              variant={expanded ? 'caretDown' : `caretRight`}
              height={'15'}
              width={'15'}
              color={'#FF6100'}
            />
          </div>
        </CardPlanHeaderStyle>
      </div>
      {/* expanded content */}
      {expanded && (
        <ExpandedContent
          selectedCountry={selectedCountry}
          groupKey={groupKey}
          expanded={expanded}
          // setExpanded={setExpanded}
          items={items}
          onSelectItem={onSelectItem}
          onSEOAddonChange={onSEOAddonChange}
          groupCustomFields={groupCustomFields}
          onGroupCustomFieldsUpdate={onGroupCustomFieldsUpdate}
          disabled={getGroupLevelStatus()}
          disabledItems={disabledItems}
          addedToCart={addedToCart}
          {...extraProps}
        />

        // fetchCardComponent({})
      )}
    </KP11LinkCatalogCardWrapperStyle>
  )
}
